import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../01_atoms/Link';
import NewTabIcon from '../../../public/static/icons/new-tab.svg';
import DownloadFileIcon from '../../../public/static/icons/download-file.svg';
import PdfIcon from '../../../public/static/icons/types-formats/format-pdf.svg';
import DocIcon from '../../../public/static/icons/types-formats/format-doc.svg';
import ExelIcon from '../../../public/static/icons/types-formats/format-excel.svg';
import PowerPointIcon from '../../../public/static/icons/types-formats/format-powerpoint.svg';
import ZipIcon from '../../../public/static/icons/types-formats/format-zip.svg';
import VideoIcon from '../../../public/static/icons/types-formats/format-video.svg';
import AudioIcon from '../../../public/static/icons/types-formats/format-audio.svg';
import UndefinedFormatIcon from '../../../public/static/icons/types-formats/format-undefined.svg';

const supportedFilesFormats = {
  PDF: PdfIcon,
  DOCX: DocIcon,
  DOC: DocIcon,
  XLSX: ExelIcon,
  XLS: ExelIcon,
  PPTX: PowerPointIcon,
  PPT: PowerPointIcon,
  ZIP: ZipIcon,
  AVI: VideoIcon,
  MP4: VideoIcon,
  MP3: AudioIcon,
  TXT: UndefinedFormatIcon,
};

import styles from './index.module.scss';

const ResourceDownload = ({
  downloadURL,
  title,
  format = 'undefined',
  info = '',
  description = '',
  actionIcon = 'download',
  variant = 'default',
}) => {
  const FileIcon = supportedFilesFormats[format] || supportedFilesFormats['TXT'];
  const ActionIcon = actionIcon === 'download' ? DownloadFileIcon : NewTabIcon;
  return (
    <Link href={downloadURL}>
      <a
        className={`${styles['resource-download']} ${styles[`resource-download--${variant}`]}`}
        target="_blank"
        title={title}
        data-analytics="analytics-bb-resources-download-item"
      >
        <div className={styles['resource-download__container']}>
          <FileIcon
            className={`${styles['resource-download__icon-filetype']} ${
              styles[`resource-download__format--${format}`]
            }`}
          />
          <div className={styles['resource-download__details']}>
            <div>
              <div className={styles['resource-download__title']}>{title}</div>
              {info && <div className={styles['resource-download__info']}> ({info})</div>}
            </div>
            {!!description && (
              <div className={styles['resource-download__description']}>{description}</div>
            )}
          </div>
          <ActionIcon
            className={styles[`resource-download__action-icon-${actionIcon}`]}
            aria-label={actionIcon === 'download' ? 'Download a file' : 'Opens a new window'}
          />
        </div>
      </a>
    </Link>
  );
};

ResourceDownload.propTypes = {
  title: PropTypes.string.isRequired,
  downloadURL: PropTypes.string.isRequired,
  info: PropTypes.string,
  description: PropTypes.string,
  actionIcon: PropTypes.oneOf(['download', 'tab']),
  format: PropTypes.oneOf([
    'PDF',
    'DOC',
    'DOCX',
    'XLSX',
    'XLS',
    'PPTX',
    'PPT',
    'ZIP',
    'AVI',
    'MP4',
    'MP3',
    'TXT',
    'undefined',
  ]),
  variant: PropTypes.oneOf(['default', 'activism']),
};

export default ResourceDownload;
